import React from 'react';
import Footer from '../Footer/Footer';
import Head from '../Head/Head';
import './Raw.css';

const RawView = () => {
    return (
        <div className='bg'>
            <Head />
            <div  className='container'>
                <div id="rwpart" class="mapouter"><div class="gmap_canvas"><iframe style={{ width: "100%", height: "500px" }} id="gmap_canvas" src="https://maps.google.com/maps?q=Sundarbans,%20Bangladesh&t=k&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                </div></div>
                <Footer/>
            </div>
            <div>
                
            </div>
        </div>
    );
};

export default RawView;